var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_203_25112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3198 0.71875H6.78951C3.36234 0.71875 0.574219 3.50687 0.574219 6.93404V17.4645C0.574219 20.8915 3.36234 23.6796 6.78951 23.6796H17.32C20.7469 23.6796 23.5351 20.8915 23.5351 17.4645V6.93404C23.5351 3.50687 20.7469 0.71875 17.3198 0.71875ZM22.189 17.4645C22.189 20.1493 20.0047 22.3335 17.3198 22.3335H6.78951C4.10457 22.3335 1.92028 20.1493 1.92028 17.4645V6.93404C1.92028 4.2491 4.10457 2.06481 6.78951 2.06481H17.32C20.0047 2.06481 22.189 4.2491 22.189 6.93404V17.4645Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0536 5.92188C8.59172 5.92188 5.77539 8.7382 5.77539 12.2001C5.77539 15.6619 8.59172 18.4782 12.0536 18.4782C15.5154 18.4782 18.3318 15.6619 18.3318 12.2001C18.3318 8.7382 15.5154 5.92188 12.0536 5.92188ZM12.0536 17.1322C9.33412 17.1322 7.12145 14.9197 7.12145 12.2001C7.12145 9.4806 9.33412 7.26794 12.0536 7.26794C14.7732 7.26794 16.9857 9.4806 16.9857 12.2001C16.9857 14.9197 14.7732 17.1322 12.0536 17.1322Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4821 3.6875C17.459 3.6875 16.627 4.51977 16.627 5.54263C16.627 6.56566 17.459 7.39793 18.4821 7.39793C19.5051 7.39793 20.3374 6.56566 20.3374 5.54263C20.3374 4.51959 19.5051 3.6875 18.4821 3.6875ZM18.4821 6.05169C18.2014 6.05169 17.973 5.82326 17.973 5.54263C17.973 5.26182 18.2014 5.03356 18.4821 5.03356C18.7629 5.03356 18.9913 5.26182 18.9913 5.54263C18.9913 5.82326 18.7629 6.05169 18.4821 6.05169Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_25112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.9609,
    height: 22.9609,
    fill: "white",
    transform: "translate(0.574219 0.71875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.3cbde802af18033a049f60a31c34af50.svg";
export { ForwardRef as ReactComponent };